import { Component } from '@angular/core';
import { NavController, NavParams, Platform, AlertController } from 'ionic-angular';
//import { AppAvailability, Device } from 'ionic-native';
import { GlobalVars } from '../../providers/global-vars';
import { ApiCaller } from '../../providers/api-caller';


/*
  Generated class for the AccessCodes page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-access-codes',
  templateUrl: 'access-codes.html'
})
export class AccessCodesPage {

    public theValue: any;
    public whichAccessCode: any;
    public texts:any = {};
    public invalidCounter:any = 0;

    public doingPhone:any = false;
    public done:any = false;

    public whereAmI:any = 'browser';
  constructor(public navCtrl: NavController, public apiCaller : ApiCaller,
               public navParams: NavParams, public globalVars : GlobalVars, public platform: Platform,
                public alertCtrl: AlertController) {
      this.theValue = navParams.get('deepAccessCode');
      if (this.theValue && this.theValue == ':deepAccessCode')
          this.theValue = null;
      console.log(" Got AC: "+this.theValue);
      if (this.theValue){
          this.clickNext();
      }else{
        this.setTexts();
      }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AccessCodesPage');
      this.openApp();
  }
    setTexts(){
        if (this.done){
            this.texts.instructions = 'Please check your phone for further instructions.';
            return;
        }
        if (!this.doingPhone){
            this.texts.instructions = 'Enter your access code below';
            this.texts.placeholder = 'Access Code'
        }else{
            this.texts.instructions = 'Enter your phone number below so we can send you access to this gate';
            this.texts.placeholder = 'Phone number'
        }
    }
    openApp(){
        console.log('in OpenApp');
        if (!this.whichAccessCode)
            return;
        window.open('gategoing://app/ac/'+this.whichAccessCode, '_system');
        
    }
    
    clickNext(){
        console.log('in clickNext');
        if (this.doingPhone){
            this.texts.phoneNumber = this.theValue;
            this.normalizeNumber();
        }else{
            if (!this.theValue || this.theValue.length <= 0){
                this.globalVars.showAlert('Error','Please enter an Access Code');
                return;
            }
            this.doingPhone = true;
            this.texts.accessCode = this.theValue;
            this.theValue = '';
            this.setTexts();
        }
    }
    normalizeNumber(){
        if (!this.texts.phoneNumber || this.texts.phoneNumber.length <= 0){
            this.globalVars.showAlert('Error','Please enter your phone number');
            return;
        }
        console.log("Processing AC: "+this.texts.accessCode+" and phone: "+this.texts.phoneNumber);
        var requestApp = {};
        (requestApp as any).requestType = 'validatePhoneNumber';
      
        (requestApp as any).request = {};
        (requestApp as any).request.phoneNumber = this.texts.phoneNumber;
        (requestApp as any).request.countryCode = this.globalVars.ipCountry;
        
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, this.invalidCounter < 2).then(data => {
            if (data && (data as any).result == 200){
                console.log('Got back: '+JSON.stringify(data));
                this.texts.phoneNumber = (data as any).data.normalizedPhoneNumber.replace('T','');
                this.theValue = this.texts.phoneNumber;
                this.continue((data as any).data.displayNumber.replace('T',''));
            }else{
                this.invalidCounter++;
                if (this.invalidCounter > 2){
                    this.globalVars.showAlert('Problem?','Try entering your phone number including a + and the country code, for example: +1 786 678 6789');
                }
            }
        });
    }
    
    sendToPhone(){
        console.log("In sendToPhone");
        var requestApp = {};
        (requestApp as any).requestType = 'websiteAccessCodeToPhone';
      
        (requestApp as any).request = {};
        (requestApp as any).request.phoneNumber = this.texts.phoneNumber;
        (requestApp as any).request.accessCode = this.texts.accessCode;
        
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
            if (data && (data as any).result == 200){
                console.log('Got back: '+JSON.stringify(data));
                this.done = true;
                this.setTexts();
            }
        });
    }
    continue(displayNumber){
       
        let confirm = this.alertCtrl.create({
          title: 'Is this right?',
          message: 'We will be sending you the Gate Access information to '+displayNumber,
          buttons: [
            {
              text: this.globalVars.msgEdit,
              handler: () => {
                return;
              }
            },
            {
              text: this.globalVars.msgContinue,
              handler: () => {
                 
                  this.sendToPhone();
                  return;
              }
            }
          ]
        });
        confirm.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/access-codes/access-codes.ts